import React from 'react'

import { ESurveyHistoryStatus } from '@/libs/apis/queries/use-get-list-survey-history-query'

export default function EarnRewardSection({
  isRewarded,
  status,
}: Readonly<{
  isRewarded?: boolean
  status?: ESurveyHistoryStatus
}>) {
  let message = ''

  if (status === ESurveyHistoryStatus.REJECTED) {
    message = 'rejected'
  } else if (status === ESurveyHistoryStatus.AUTO_DISQUALIFIED) {
    message = 'disqualified'
  } else if (status === ESurveyHistoryStatus.SCREEN_OUT) {
    message = 'screened out'
  }

  if (
    !isRewarded ||
    (status !== ESurveyHistoryStatus.REJECTED &&
      status !== ESurveyHistoryStatus.AUTO_DISQUALIFIED &&
      status !== ESurveyHistoryStatus.SCREEN_OUT)
  ) {
    return null
  }

  return (
    <div className='w-full rounded-lg text-left text-xs font-normal text-neutral-grey-600'>
      Submission is {message}, but you have earned a participation reward.
    </div>
  )
}
